/**
 * BlockLoader — индикатор загрузки данных блока/виджета: спиннер +
 * «Загрузка...» (i18n). Вешается на виджеты и инфо-блоки, пока идёт
 * запрос к бэку, вместо мигания «Нет данных»/«—».
 */
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from '../../lib/cn';

interface BlockLoaderProps {
  className?: string;
  testId?: string;
}

export const BlockLoader = ({
  className,
  testId = 'block-loader',
}: BlockLoaderProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        'flex items-center justify-center gap-2.5 py-8 text-sm text-text-muted',
        className,
      )}
      data-testid={testId}
      role="status"
    >
      <Loader2
        className="size-5 shrink-0 animate-spin text-brand-600"
        aria-hidden="true"
      />
      {t('common.loading')}
    </div>
  );
};
